export function dateIsValid(value: string): boolean {
  try {
    // ISO format kontrolü (2025-08-07T14:58:09.090742)
    if (value.includes("T") && value.includes("-")) {
      const date = new Date(value);
      return !isNaN(date.getTime());
    }

    // Eski format kontrolü (07/Aug/2025 14:58)
    const [day, monStr, yearAndTime] = value.split("/");
    const [year, time] = yearAndTime.split(" ");
    const [hour, minute] = time.split(":");

    const monthMap: Record<string, number> = {
      Jan: 0,
      Feb: 1,
      Mar: 2,
      Apr: 3,
      May: 4,
      Jun: 5,
      Jul: 6,
      Aug: 7,
      Sep: 8,
      Oct: 9,
      Nov: 10,
      Dec: 11,
    };

    const month = monthMap[monStr];
    if (month === undefined) return false;

    const date = new Date(parseInt(year), month, parseInt(day), parseInt(hour), parseInt(minute));

    let parsedDate = isNaN(date.getTime()) ? null : date;
    return parsedDate === null ? false : true;
  } catch (error) {
    return false;
  }
}
